import { CheckboxIconTheme, styles, variants } from '../CheckboxIconStyles.css';
import { baseTheme } from './CheckboxIconBaseTheme.css';
import { multiVariantStyles } from './CheckboxIconVariants.css';

/*******************
 * Component Theme
 *******************/

const CheckboxIconStableTheme: CheckboxIconTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { CheckboxIconStableTheme };
